import * as React from 'react';
import { Grid } from '@material-ui/core';
import { StyledRequiredLabelContainer, StyledRequiredLabelIndicator, StyledSpan } from './style';
const DEFAULT_ID_PREFIX = 'label-value-pair';
/**
 * Props for LabelValuePair component
 * @param {string} [label] label for label-value pair
 * @param {React.ReactNode} children - child component that could be <Value/> component or any input component
 * @param {string} [idPrefix] idPrefix for label-value pair
 */
export const LabelValuePair = ({ label, children, idPrefix = DEFAULT_ID_PREFIX, isRequired, isResolved }) => (React.createElement(Grid, { container: true, direction: "column" },
    React.createElement(Grid, { container: true, direction: "row" },
        isRequired && (React.createElement(StyledRequiredLabelContainer, { isResolved: isResolved },
            React.createElement(StyledRequiredLabelIndicator, null, '*'))),
        label && React.createElement(StyledSpan, { id: `${idPrefix}__label` }, label)),
    React.createElement("div", { id: `${idPrefix}__value` },
        " ",
        children,
        " ")));
//# sourceMappingURL=LabelValuePair.js.map